<div class="LoginPageMain">
    <div class="appLogo MobileShow">
        <img [src]="userLogo">
    </div>
    <div class="AlignCenter">
        <div class="loginBox">
            <!-- Carousel Section -->
            <div class="box boxLeft">
                <div class="UpdatesText" *ngIf="notClosed">
                    <h3>Lorem Ipsum is simply dummy texts of the printing</h3>
                    <p>Orem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type Changed.</p>
                    <a class="btn">Learn More</a>
                    <button class="CloseIcon" (click)="closeMessageBox()">
                        <i class="fa-solid fa-circle-xmark"></i>
                    </button>
                </div>
                <app-showcase-carousel class="SliderBox"></app-showcase-carousel>
            </div>

            <!-- <div class="FormHeadingMobile MobileShow">{{ 'page.setPassword.resetHeading' | translate }}</div> -->

            <!-- Forms Section -->
            <div class="box boxRight">
                <div>
                    <div class="appLogo MobileHide">
                        <img [src]="userLogo">
                    </div>
                    <div class="FormContainer">
                        <div class="FormHeading">{{ 'page.setPassword.resetHeading' | translate }}</div>
                        <div class="greyCapsuleMain"><p class="greyCapsule" *ngIf="accessCode">Access Code: {{ accessCode.toUpperCase() }}</p></div>
 <div class="OrangeInfoText MobileShow">Password must be at least 8 characters long and contain at least 1 uppercase letter, 1 number, and 1 special character.</div>
                        <app-form-notification *ngIf="notificationShown" [type]="notificationType" (close)="showNotificationFor(null)"></app-form-notification>
                        <form [formGroup]="setPasswordForm" (ngSubmit)="onSubmit()">
                            <div class="FormBox relative">
                                <!-- <div class="formHintText">
                                    {{ "page.setPassword.subtitle" | translate }}
                                </div> -->
                                <div class="FormGrpTooltip">
                                <mat-form-field class="w-full" appearance="fill">
                                    <mat-label>{{ 'page.setPassword.newPassword' | translate }}</mat-label>
                                    <input matInput maxlength="20" [type]="showNewPassword ? 'text' : 'password'" formControlName="newPassword"
                                    (input)="checkPasswordStrength(setPasswordForm.get('newPassword')?.value)" />
                                    <mat-error *ngIf="setPasswordForm.get('newPassword')?.hasError('strength')">
                                        {{ setPasswordForm.get('newPassword')?.getError('strength') }}
                                    </mat-error>
                                    <div class="password-toggle-strength" style="right:25px;">
                                        <span class="password-strength-text" [ngClass]="passwordStrength">{{ passwordStrength }}</span>
                                        <button mat-icon-button (click)="toggleNewPasswordVisibility()" type="button">
                                            <mat-icon>{{ showNewPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                                        </button>
                                    </div>
                                    <div class="password-strength-bar" [ngClass]="passwordStrength"></div>
                                </mat-form-field>
                                <div class="PasswordInfoIcon">
                                    <div class="CustomTooltip">
                                       <mat-icon>info</mat-icon>
                                       <span class="CustomTooltiptext">Password must be at least 8 characters long and contain at least 1 uppercase letter, 1 number, and 1 special character.</span>
                                    </div>
                                 </div>
                                </div>
                                <mat-form-field class="w-full" appearance="fill">
                                    <mat-label>{{ 'page.setPassword.confirmPassword' | translate }}</mat-label>
                                    <input matInput [type]="showConfirmPassword ? 'text' : 'password'" maxlength="20" formControlName="confirmPassword"  (blur)="setPasswordForm.get('confirmPassword')?.markAsTouched()" />
                                  
                                    <mat-error *ngIf="setPasswordForm.get('confirmPassword')?.hasError('required')">
                                        Confirm New password is required.
                                    </mat-error>
                                    <mat-error *ngIf="setPasswordForm.get('confirmPassword')?.hasError('passwordMismatch') && setPasswordForm.get('confirmPassword')?.touched">
                                        {{ 'page.setPassword.passwordMismatch' | translate }}
                                      </mat-error>
                                      <mat-error *ngIf="setPasswordForm.get('confirmPassword')?.hasError('apiErrorMessage')">
                                        {{ setPasswordForm.get('confirmPassword')?.getError('apiErrorMessage') }}
                                      </mat-error>  
                                    <!-- <mat-error *ngIf="apiErrorMessage">{{ apiErrorMessage }}</mat-error> -->
                                      <div class="password-toggle-strength">
                                        <span class="password-strength-text" [ngClass]="passwordStrength">{{ passwordStrength }}</span>
                                        <button mat-icon-button (click)="toggleConfirmPasswordVisibility()" type="button">
                                            <mat-icon>{{ showConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                                        </button>
                                    </div>
                                </mat-form-field>
                                
                            </div>
                            <div class="BtnWrapper">
                                <button id="btlBackToLogin" type="submit" [disabled]="setPasswordForm.invalid">{{ 'page.setPassword.setPasswordButton' | translate }}</button>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="devText">{{"page.login.version"|translate}}</div>
            </div>
        </div>
    </div>
</div>
